import React from 'react';
import { Box, Alert, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export function ChainInfoAlert({ chainLength, taskTitle }) {
  const { t } = useTranslation(['common', 'tasks']);

  return (
    <Box mt={3}>
      <Alert severity="info" icon={<InfoIcon />}>
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{
            __html: chainLength === 1
              ? t('tasks:recurrence_history.viewing_task', {
                  title: taskTitle || t('common:unknown'),
                  count: chainLength
                })
              : t('tasks:recurrence_history.viewing_task_plural', {
                  title: taskTitle || t('common:unknown'),
                  count: chainLength
                })
          }}
        />
      </Alert>
    </Box>
  );
}
